import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import CastingCommon    from '@utils/casting-common';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DraftCheckRemove extends React.Component {
  actionEvent(update) {
    let detail = this.props.detail;
    
    let chk = confirm('「下書き確認済み」の状態から「下書き作成」の状態に変更してもよろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/influencer/draft_check_remove', { project_id: detail.project_id, insta_user_id: detail.insta_user_id },
      function(res){
        this.props.close_ev.bind(this)();
        this.props.base.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    let request_action = CastingCommon.getRequestAction(this.props.base, this.props.detail.insta_user_id, 'full_task');
    
    // アクション
    if( detail.workflow_status.is_draft_complete == 1){
      return (
        <li className="on" onClick={this.actionEvent.bind(this)}>
          {this.props.button}
        </li>
      );
    }
    
    // 使用できない
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>下書きの確認が完了していません</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftCheckRemove;